import { inject } from '@angular/core';
import { ActivatedRouteSnapshot,CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';

export const AuthGuard: CanActivateFn = (route:ActivatedRouteSnapshot, state:RouterStateSnapshot):Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree => {
  const router :Router = inject(Router);
  const authService :AuthService= inject(AuthService);
  if (!authService.isLoggedIn()) {
    return true;
  } else {
    // Redirect to the login page if the user is not authenticated
    router.navigate(['/secure/login']);
    authService.logout()
    return false;
  }
};
